import palette from '../palette';

export default {
  root: {
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: palette.primary.light,
    },
  },
};
